import React, { memo } from "react";
import { useTable, usePagination } from "react-table";
import Pagination from "@mui/material/Pagination";
import Button from "./Button";

const Table = ({ columns, data }) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    state: { pageIndex },
  } = useTable({ columns, data }, usePagination);

  return (
    <>
      <div
        style={{
          marginTop: "21px",
          overflow: "auto",
          width: "100%",
          border: "solid 1px #dbdbdb",
        }}
      >
        <table {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => {
                  return (
                    <th
                      {...column.getHeaderProps()}
                      colSpan={1}
                      style={{
                        background: "#fff",
                        color: "#003E85",
                        fontFamily: "Roboto-Regular",
                        fontSize: "14px",
                        textAlign: "left",
                        paddingLeft: "10px",
                        overflow: "hidden",
                        minWidth: column.maxWidth,
                        height: "50px",
                      }}
                    >
                      {column.render("Header")}
                    </th>
                  );
                })}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td
                        {...cell.getCellProps()}
                        style={{
                          padding: "10px",
                          color: "#060808",
                          overflow: "hidden",
                          width: "300px",
                          fontFamily: "Roboto-Regular",
                          fontSize: "12px",
                        }}
                      >
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div
        style={{
          marginTop: "20px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <text
          style={{
            color: "#515353",
            fontFamily: "Roboto-Regular",
            fontSize: "12px",
          }}
        >{`Showing ${page?.length ?? 0} out of ${
          data?.length ?? 0
        } entries`}</text>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Button
            label={"Previous"}
            labelColor={"white"}
            type={"button"}
            fontSize={"12px"}
            disabled={!canPreviousPage}
            style={{
              height: 28,
              borderRadius: 4,
              paddingLeft: 10,
              paddingRight: 10,
              marginRight: 12,
              textTransform: "none",
              fontWeight: 500,
            }}
            onClick={() => canPreviousPage && previousPage()}
          />
          <Pagination
            page={pageIndex + 1}
            onChange={(val, page) => gotoPage(page - 1)}
            count={pageOptions.length}
            shape="rounded"
            hidePrevButton
            hideNextButton
          />
          <Button
            label={"Next"}
            labelColor={"white"}
            type={"button"}
            fontSize={"12px"}
            disabled={!canNextPage}
            style={{
              height: 28,
              borderRadius: 4,
              paddingLeft: 10,
              paddingRight: 10,
              marginLeft: 12,
              textTransform: "none",
              fontWeight: 500,
            }}
            onClick={() => canNextPage && nextPage()}
          />
        </div>
      </div>
    </>
  );
};

export default memo(Table);
